import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import type { FetchAboutUsContentSuccessResponse } from '@/modules/Core/types/api/response/aboutus'

export const QUERY_KEY = 'about-us-content'
const ENDPOINT = 'CustomerProfile/Content/AboutUs'

export function fetchAboutUsContent() {
  return axiosInstance
    .get<FetchAboutUsContentSuccessResponse>(ENDPOINT)
    .then((response) => response.data.data)
}

export function useAboutUsContentQuery(
  options?: UseQueryOptions<Awaited<ReturnType<typeof fetchAboutUsContent>>>
) {
  return useQuery({
    queryFn: fetchAboutUsContent,
    queryKey: [QUERY_KEY],
    ...options,
  })
}
